module.exports = __webpack_public_path__ + "static/media/problem-with-hairs.29d4eafb.md";